import { useQuery } from '@tanstack/react-query';

import { Badge, Card, EmptyState, Spinner } from '../../components/ui';
import { api } from '../../lib/api';

interface Staff {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  role: string;
  emailVerifiedAt: string | null;
  lastLoginAt: string | null;
}

export function UsersPage() {
  const { data, isLoading } = useQuery<{ items: Staff[] }>({
    queryKey: ['users'],
    queryFn: async () => (await api.get('/admin/users')).data,
  });

  return (
    <div className="space-y-4">
      <h1 className="font-display text-3xl">Staff</h1>

      {isLoading ? (
        <Spinner />
      ) : (data?.items ?? []).length === 0 ? (
        <EmptyState title="No staff yet" description="Invite teammates from here." />
      ) : (
        <Card>
          <table className="w-full">
            <thead className="bg-cream-200">
              <tr>
                <th className="text-left px-4 py-2 text-sm font-medium">Name</th>
                <th className="text-left px-4 py-2 text-sm font-medium">Email</th>
                <th className="text-left px-4 py-2 text-sm font-medium">Role</th>
                <th className="text-left px-4 py-2 text-sm font-medium">Verified</th>
              </tr>
            </thead>
            <tbody>
              {data!.items.map((u) => (
                <tr key={u.id} className="border-t border-cream-300">
                  <td className="px-4 py-2">
                    {u.firstName} {u.lastName}
                  </td>
                  <td className="px-4 py-2 text-sm">{u.email}</td>
                  <td className="px-4 py-2">
                    <Badge>{u.role}</Badge>
                  </td>
                  <td className="px-4 py-2 text-sm">{u.emailVerifiedAt ? '✓' : '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Card>
      )}

      {/* TODO(section-4): invite modal (POST /admin/users), role change, deactivate */}
    </div>
  );
}
